export default __webpack_public_path__ + "static/N0065-3c28da769e5df3784ca4d27e7f204e24.png";